// extracted by mini-css-extract-plugin
export var checkbox = "_6l-0";
export var circle = "_6l-3";
export var horizontalContainer = "_6l-7";
export var sm = "_6l-5";
export var switch0 = "_6l-2";
export var switchDisabled = "_6l-8";
export var switchEnabled = "_6l-1";
export var textSwitchContainer = "_6l-9";
export var textSwitchOption = "_6l-a";
export var textSwitchOptionSelected = "_6l-b";
export var verticalContainer = "_6l-6";
export var xs = "_6l-4";